import React, { useState } from 'react'
import { Dialog, DialogContent, DialogHeader } from '../../components/ui/dialog';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '../../components/ui/dropdown-menu';
import CustomButton from '../../components/customButton';
import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import useAddessDeliveryStore from '../../store/addresse/addDeliveries';
import { toast } from 'react-toastify';

type FormTabType = {
    openMoal: boolean;
    setOpenModal: (open: boolean) => void;
}
function Add_address_modal({ openMoal, setOpenModal }: FormTabType) {
    const userId = localStorage.getItem("user");
    const [loader, setLoader] = useState(false)
    const [selectedAddress, setSelectedAddress] = useState("");
    // const [adress, setAdress] = useState(false);
    const [region, setRegion] = useState();
    const [selectedCity, setSelectedCity] = useState("Yaounde");
    const [selectedCountry, setSelectedCountry] = useState("Cameroun");
      const [detailUser, setDelaisUser] = useState({
        selectedAddress: "",
        region: "",
        selectedCity: "",
        selectedCountry: selectedCountry,
        fullName: "",
        phoneNumber: ``,
        user_id: parseInt(userId ?? ""),
    })
    const [fullName, setFullName] = useState("fullName");
    const [phoneNumber, setPhoneNumber] = useState("");
    const { addDeliveryAddress } = useAddessDeliveryStore(
        (state) => state
    );

    const handleChange = (e: any) => {
        console.log(e.target.name)
        const { name, value } = e.target;
        setDelaisUser((prev) => ({
            ...prev,
            [name]: value,
        }));
    }
    const handleSubmit = () => {
        // setAdress(true);
        setOpenModal(true);
    };

    const formTab = [
        {
          label: "Pays",
          options: [
            "Cameroun",
          ],
          value: selectedCountry,
          name:"selectedCountry",
          onChange: setSelectedCountry,
        },
    
        {
          label: "region",
          options: [
            "Centre",
            "Littoral",
            "Nord",
            "Extreme-nord",
            "Sud",
            "Sud-ouest",
            "Nord-est",
            "Adamaoua",
            "Ouest",
            "Est",
          ],
          value: region,
          name:"region",
          onChange: setRegion,
        },
        {
            label: "Ville",
            value: selectedCity,
            name:"selectedCity",
            onChange: setSelectedCity,
          //   options: ["Yaounde", "Douala", "Kribi", "Buea", "Bamenda"],
          },
    
        {
          label: "Nom complet",
          value: fullName,
          name:"fullName",
          onChange: setFullName,
        },
        {
          label: "Numero de telephone",
          value: phoneNumber,
          name:"phoneNumber",
          onChange: setPhoneNumber,
        },
        {
          label: "Addresse",
          value: selectedAddress,
          name:"selectedAddress",
          onChange: setSelectedAddress,
        },
     
      ];

    const request = async () => {
        console.log(detailUser)
        // Vérification si tous les champs sont remplis
        if (detailUser.selectedAddress.trim()==="") {
            toast.error("L'adresse de livraison n'est pas renseignée");
            return;
        }

        if (detailUser.region.trim() ==="") {
            toast.error("La région n'est pas renseignée");
            return;
        }
        if (detailUser.selectedCity.trim()==="") {
            toast.error("La ville de livraison n'est pas renseignée");
            return;
        }
        if (detailUser.selectedCountry.trim()==="") {
            toast.error("Le pays de livraison n'est pas renseigné");
            return;
        }
        if (detailUser.fullName.trim()==="") {
            toast.error("Le nom complet n'est pas renseigné");
            return;
        }
        if (detailUser.phoneNumber.trim()==="") {
            toast.error("Le numéro de téléphone n'est pas renseigné");
            return;
        }
        setLoader(true)
        try {
            // Appel pour ajouter l'adresse de livraison
            await addDeliveryAddress({
                delivery_address: detailUser.selectedAddress,
                delivery_region: detailUser.region,
                delivery_city: detailUser.selectedCity,
                delivery_country: detailUser.selectedCountry,
                delivery_name: detailUser.fullName,
                delivery_phone_number: `+237${detailUser.phoneNumber}`,
                user_id: parseInt(userId ?? ""),
                /*  order_details: (cartDetails?.data || []).map((item) => ({
                  product_id: item.product.product_id,
                  quantity: item.quantity,
                })), */
            });

            // Si l'opération réussit, redirige vers la page de paiement
            setOpenModal(false);
        } catch (error) {
            console.error("Error adding delivery address:", error);
            toast.error("Erreur lors de l'ajout de l'adresse de livraison");
        }finally{
            setLoader(false)
        }
    };
    const { t } = useTranslation()
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <Dialog open={openMoal} onOpenChange={setOpenModal}>
                <DialogContent>
                    <DialogHeader>
                        <div className="bg-primary p-2 mt-5  overflow-y-auto flex justify-between sm:rounded-lg">
                            <span className="text-[17px] text-white">
                                {t("saisir_addresse_livraison")}
                            </span>
                            <img
                                onClick={() => setOpenModal(false)}
                                className="cursor-pointer"
                                src="/closeIcon.svg"
                                alt=""
                            />
                        </div>
                    </DialogHeader>

                    <div className="px-5 pt-2 pb-5 flex flex-col gap-3">
                        {formTab.map((item, index) => (
                            <div key={index}>
                                <label className="text-[11px]">{item.label}</label>
                                <div className="max-h-[40px]">
                                    {item.options ? (
                                        <DropdownMenu>
                                            <DropdownMenuTrigger className="w-full">
                                                <CustomButton className="bg-softGrey text-[13px] flex justify-between px-4 py-2 w-full">
                                                    {item.value} <ChevronDown />
                                                </CustomButton>
                                            </DropdownMenuTrigger>
                                            <DropdownMenuContent className="w-56">
                                                <DropdownMenuGroup>
                                                    {item.options.map((option: any, idx: number) => (
                                                        <DropdownMenuItem
                                                            key={idx}
                                                            onClick={() =>{
                                                                item.onChange(option)
                                                                 handleChange({ target: { name: item.name, value: option } })
                                                                }}
                                                        >
                                                            <span>{option}</span>
                                                        </DropdownMenuItem>
                                                    ))}
                                                </DropdownMenuGroup>
                                                <DropdownMenuSeparator />
                                            </DropdownMenuContent>
                                        </DropdownMenu>
                                    ) : (
                                        <input
                                            name={item.name}
                                            className="placeholder:text-grey px-3 text-xs py-3 font-normal min-h-full w-full bg-softGrey border-none focus:outline-none"
                                            // value={item.value}
                                            onChange={(e) => handleChange(e)}
                                        />
                                    )}
                                </div>
                            </div>
                        ))}

                        <div className="flex w-full justify-center mt-3">
                            <CustomButton
                                className="text-white mb-5 text-[11px] w-full max-w-[240px] px-4 py-2 bg-primary"
                                rounded
                                onClick={() => {
                                    request();
                                    handleSubmit();
                                }}
                            >
                                <span>{ loader? `${t("enregistrement")}...`: t("ajouter_cet_addresse")}</span>
                            </CustomButton>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default Add_address_modal
